// @flow
import {
  createSelector,
} from 'reselect';

import type {
  Selector,
} from 'reselect';
import type {
  State,
  ResourceType,
  Resources,
} from '../types';

export {
  getResources,
} from 'redux-resource';

export function getResourceIds<T: ResourceType, L: string>(
  resourceType: T,
  list: L,
): (State) => $ElementType<$PropertyType<$ElementType<State, T>, 'lists'>, L> {
  return state => (
    state[resourceType].lists[list] || []
  );
}

export function getResourceAllIds<T: ResourceType >(
  resourceType: T,
): (State) => Array<ID> {
  return state => (
    Object.keys(state[resourceType].resources)
  );
}

export function getResourceMap<T: ResourceType>(
  resourceType: T,
): (State) => $PropertyType<$ElementType<State, T>, 'resources'> {
  return state => (
    state[resourceType].resources
  );
}

const resourceSelectors = {};

/* Selector which return list of resources without relationships */
export function getResourceMappedList(
  resourceType,
  list,
) {
  if (resourceSelectors[resourceType]) {
    return resourceSelectors[`${resourceType}${list}`];
  }
  resourceSelectors[`${resourceType}${list}`] = (
    createSelector(
      [
        getResourceIds(resourceType, list),
        getResourceMap(resourceType),
      ],
      (
        ids = [],
        map,
      ) => (
        ids.map(id => map[id])
      ),
    )
  );
  return resourceSelectors[`${resourceType}${list}`];
}

export function getResourceMappedAllList<T: ResourceType>(
  resourceType: T,
): Selector<State, any, Array<$PropertyType<$ElementType<State, T>, 'resources'>>> {
  if (resourceSelectors[resourceType]) {
    return resourceSelectors[`${resourceType}ALL`];
  }
  resourceSelectors[`${resourceType}ALL`] = (
    createSelector(
      [
        getResourceMap(resourceType),
      ],
      map => (
        Object.keys(map).map(id => map[id])
      ),
    )
  );
  return resourceSelectors[`${resourceType}ALL`];
}

export function getResourceItemBydId<T: ResourceType, I: ID>(
  resourceType: T,
  id: I,
): (State) => $ElementType<$PropertyType<$ElementType<State, T>, 'resources'>, I> {
  return state => (
    state[resourceType].resources[id] || null
  );
}
